var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon_info_svg__a",
    d: "M0 32h32V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9 6.1A14.002 14.002 0 0016 2C8.268 2 2 8.267 2 16s6.268 14 14 14 14-6.268 14-14a14 14 0 00-4.1-9.9",
    fill: "#FF6400"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "icon_info_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_info_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    mask: "url(#icon_info_svg__b)",
    d: "M14.5 23h3v-9h-3zM18 10a2 2 0 11-4.002-.002A2 2 0 0118 10"
  }))));
}

export default SvgIconInfo;